module.exports = __webpack_public_path__ + "media/images/area/feature/kyushu/related/id_2-1226afc459dbf6c8a1141227cf00ea70.jpg";